<template>
  <div>
    <div class="content">
      <!--      <div class="content-main">-->
      <!--        <p class="content-title">用户权限</p>-->
      <!--      </div>-->
      <div class="content-main">
        <p class="content-title" style="padding-bottom: 16px;">通过码-入口权限管理</p>
<!--        <div class="content-button">-->
<!--          <div>-->
<!--            <el-button type="primary" @click="editUserDialog(-1)" size="default">创建用户</el-button>-->
<!--          </div>-->
<!--          <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>-->
<!--        </div>-->
        <el-form ref="form" :model="form" label-width="160px" v-loading="dataLoading" style="margin: 48px 0;">
          <el-form-item label="上次提交时间">
            {{form.lastSubTime}}<el-button type="primary" @click='submit()' v-loading="dataLoading" style="margin-left: 140px">整体提交按钮</el-button>
          </el-form-item>
          <!--是否执行-->
          <el-form-item label="入口权限开关">
            <el-radio-group v-model="form.totalPermissionState">
              <el-radio :label="1">开</el-radio>
              <el-radio :label="0">关</el-radio>
            </el-radio-group>
            <!--            {{form.totalPermissionState}}-->
          </el-form-item>
          <!--提交时间-->
          <el-form-item label="">
            <template #label>
              <span style="font-size: 12px; color: #aaaaaa">微信提交时间：</span>
            </template>
          </el-form-item>
          <el-form-item label="不分配的日期">
            <el-date-picker v-model="form.startDate" type="date" value-format="YYYY-MM-DD" style="width: 10.4em;" placeholder="开始日期" :disabled="checkDate"></el-date-picker>
            &nbsp;-&nbsp;
            <el-date-picker v-model="form.endDate" type="date" value-format="YYYY-MM-DD" style="width: 10.4em;" placeholder="结束日期" :disabled="checkDate"></el-date-picker>
            <el-checkbox class="check" v-model="checkDate" @change="noDate()" >不限时间</el-checkbox>
            <!--            <quary-time @date="getDay($event)" title="" style="display: inline-block" ></quary-time>-->
            <!--            {{ form.startDate}}{{form.endDate}}-->
          </el-form-item>
          <div class="clear"></div>
          <el-form-item label="不分配的时间">
            <el-select v-model="form.startTime" placeholder="请选择" style="width: 10.4em;" filterable :disabled="checkTime">
              <el-option v-for="item in timeArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
              </el-option>
            </el-select>
            &nbsp;-&nbsp;<span v-show="form.endTime < form.startTime">次日</span>
            <el-select v-model="form.endTime" placeholder="请选择" style="width: 10.4em;" filterable :disabled="checkTime">
              <el-option v-for="item in timeArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
              </el-option>
            </el-select>
            <el-checkbox class="check" v-model="checkTime" @change="noTime()" >不限时间</el-checkbox>
            <!--            <div v-if="form.startTime !=='' " style="display: inline-block"> {{ form.startTime + '&#45;&#45;' + form.endTime }}</div>-->
          </el-form-item>
          <!--性别-->
          <el-form-item label="性别">
            <el-radio-group v-model="form.sex" @change="sexChange()">
              <el-radio :label="-1">不限</el-radio>
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
            <!--            {{form.sex}}-->
          </el-form-item>
          <!--自定义-->
          <div v-show="selectMan">
            <el-form-item label="">
              <template #label>
                <span style="font-size: 12px; color: #aaaaaa">男生年龄身高：</span>
              </template>
            </el-form-item>
            <el-form-item label="自定义 - 年龄">
              <el-select v-model="form.manAgeMin" placeholder="请选择" style="width: 10.4em;" filterable :disabled="checkManAge">
                <el-option v-for="item in manAgeMinArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                </el-option>
              </el-select>
              &nbsp;-&nbsp;
              <el-select v-model="form.manAgeMax" placeholder="请选择" style="width: 10.4em;" filterable :disabled="checkManAge">
                <el-option v-for="item in manAgeMaxArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                </el-option>
              </el-select>
              <el-checkbox class="check" v-model="checkManAge" @change="noManAge()" >不限年龄</el-checkbox>
              <!--            {{ form.manAgeMin }}{{ form.manAgeMax }}-->
            </el-form-item>
            <el-form-item label="自定义 - 身高">
              <el-select v-model="form.manHeightMin" placeholder="请选择" style="width: 10.4em;" filterable :disabled="checkManHeight">
                <el-option v-for="item in manHeightMinArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                </el-option>
              </el-select>
              &nbsp;-&nbsp;
              <el-select v-model="form.manHeightMax" placeholder="请选择" style="width: 10.4em;" filterable :disabled="checkManHeight">
                <el-option v-for="item in manHeightMaxArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                </el-option>
              </el-select>
              <el-checkbox class="check" v-model="checkManHeight" @change="noManHeight()" >不限身高</el-checkbox>
              <!--            {{ form.manHeightMin }}-->
            </el-form-item>
          </div>
          <div v-show="selectWoman">
            <el-form-item label="">
              <template #label>
                <span style="font-size: 12px; color: #aaaaaa">女生年龄身高：</span>
              </template>
            </el-form-item>
            <el-form-item label="自定义 - 年龄">
              <el-select v-model="form.womanAgeMin" placeholder="请选择" style="width: 10.4em;" filterable :disabled="checkWomAge">
                <el-option v-for="item in womanAgeMinArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                </el-option>
              </el-select>
              &nbsp;-&nbsp;
              <el-select v-model="form.womanAgeMax" placeholder="请选择" style="width: 10.4em;" filterable :disabled="checkWomAge">
                <el-option v-for="item in womanAgeMaxArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                </el-option>
              </el-select>
              <el-checkbox class="check" v-model="checkWomAge" @change="noWomAge()" >不限年龄</el-checkbox>
              <!--            {{ form.womanAgeMin }}-->
            </el-form-item>
            <el-form-item label="自定义 - 身高">
              <el-select v-model="form.womanHeightMin" placeholder="请选择" style="width: 10.4em;" filterable :disabled="checkWomHeight">
                <el-option v-for="item in womanHeightMinArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                </el-option>
              </el-select>
              &nbsp;-&nbsp;
              <el-select v-model="form.womanHeightMax" placeholder="请选择" style="width: 10.4em;" filterable :disabled="checkWomHeight">
                <el-option v-for="item in womanHeightMaxArray" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                </el-option>
              </el-select>
              <el-checkbox class="check" v-model="checkWomHeight" @change="noWomHeight()" >不限身高</el-checkbox>
              <!--            {{ form.womanHeightMin }}-->
            </el-form-item>
          </div>
          <!--城市-->
          <el-form-item label="现在居住城市">
            <Area v-if="showArea" title=""  @areaChang='getArea($event)' style="margin: 0;" :disable="checkArea" :reset="resetArea"></Area>
            <el-button v-else :disabled="checkArea" @click="showArea = true">添加城市</el-button>
            <el-checkbox class="check" v-model="checkArea" @change="noArea()">不限城市</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-tag
                v-for="(value, index) in selectCitys"
                :key="index"
                class="mx-1"
                closable
                type="info"
                @close="delCity(index)"
                style="margin: 0 10px 10px 0"
            >
              {{ value }}
            </el-tag>
<!--            <ul>-->
<!--              <li v-for="(value, index) in selectCitys" @click="delCity(index)" class="citys">-->
<!--                {{ value }}<i class="el-icon-circle-close"></i>-->
<!--              </li>-->
<!--            </ul>-->
          </el-form-item>
          <!--提交按钮-->
<!--          <el-form-item style="padding-top: 20px">-->
<!--            -->
<!--          </el-form-item>-->
        </el-form>
      </div>

    </div>
  </div>
</template>

<script>
import { getThroughCodeLastRecord, addThroughCodeData } from '../../api/url'
import { postFormData, getFormData } from "@/api/api";
import Area from "@/components/Area";

export default {
name: "SysThroughCode",
  components: { Area },
  data() {
    return {
      form: {
        listId: '',
        lastSubTime: '',
        totalPermissionState: '',
        sex: '',
        manAgeMin: '',
        manAgeMax: '',
        manHeightMin: '',
        manHeightMax: '',
        womanAgeMin: '',
        womanAgeMax: '',
        womanHeightMin: '',
        womanHeightMax: '',
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: '',
      },

      checkTime: false,
      checkDate: false,
      checkManAge: false,
      checkManHeight: false,
      checkWomAge: false,
      checkWomHeight: false,
      checkCity: false,
      checkArea: false,
      showArea: false,
      resetArea: false,
      selectMan: true,
      selectWoman: true,
      dataLoading: false,

      timeArray: [
        {label: '不限', value: -1, disabled: true}
      ],

      // 男身高
      manHeightMinArray: [
        {label: '不限', value: -1, disabled: true}
      ],
      manHeightMaxArray: [
        {label: '不限', value: -1, disabled: true}
      ],
      // 女身高
      womanHeightMinArray: [
        {label: '不限', value: -1, disabled: true}
      ],
      womanHeightMaxArray: [
        {label: '不限', value: -1, disabled: true}
      ],
      // 男年龄
      manAgeMinArray: [
        {label: '不限', value: -1, disabled: true}
      ],
      manAgeMaxArray: [
        {label: '不限', value: -1, disabled: true}
      ],
      // 女年龄
      womanAgeMinArray: [
        {label: '不限', value: -1, disabled: true}
      ],
      womanAgeMaxArray: [
        {label: '不限', value: -1, disabled: true}
      ],


      //城市
      homeProvince: '',
      homeCity: '',
      citys: {
        type: String,
      },
      selectCitys: [],
    }
  },
  methods: {
    // //获取时间
    // getDay(el) {
    //   this.startDate = el[0];
    //   this.endDate = el[1];
    // },

    //时间
    getTimeArray() {
      let arr = [];
      for(let i = 0; i <= 24; i++) {
        if(i<10){
          arr.push({label : '0'+ i +":00", value : i})
        }else {
          arr.push({label : i +":00" , value : i})
        }
      }
      this.timeArray = this.timeArray.concat(arr);
    },

    // 身高
    getHeight() {
      let arr = [];
      for(let i = 145; i <= 200; i++) {
        arr.push({label : i + 'cm', value : i})
      }
      this.manHeightMinArray = this.manHeightMinArray.concat(arr);
      this.manHeightMaxArray = this.manHeightMaxArray.concat(arr);
      this.womanHeightMinArray = this.womanHeightMinArray.concat(arr);
      this.womanHeightMaxArray = this.womanHeightMaxArray.concat(arr);
    },

    // 年龄
    getAge() {
      let arr = [];
      for(let i = 18; i <= 80; i++) {
        arr.push({label : i , value : i})
      }
      this.manAgeMinArray = this.manAgeMinArray.concat(arr);
      this.manAgeMaxArray = this.manAgeMaxArray.concat(arr);
      this.womanAgeMinArray = this.womanAgeMinArray.concat(arr);
      this.womanAgeMaxArray = this.womanAgeMaxArray.concat(arr);
    },
    noDate(){
      this.form.startDate = '';
      this.form.endDate = ''
    },
    noTime(){
      this.form.startTime = -1;
      this.form.endTime = -1
    },
    noManAge(){
      this.form.manAgeMin = -1;
      this.form.manAgeMax = -1
    },
    noWomAge(){
      this.form.womanAgeMin = -1;
      this.form.womanAgeMax = -1
    },
    noManHeight(){
      this.form.manHeightMin = -1;
      this.form.manHeightMax = -1
    },
    noWomHeight(){
      this.form.womanHeightMin = -1;
      this.form.womanHeightMax = -1
    },
    noArea(){
      this.selectCitys = [];
      this.citys = '全国'
      this.showArea = false
      this.resetArea = !this.resetArea;
    },

    // 现居城市
    getArea(el) {
      this.homeProvince = el.prov;
      this.homeCity = el.city;
      if(this.homeCity != '' && this.homeCity != null){
        let c = this.selectCitys.indexOf(this.homeCity);
        if(c == -1){
          this.selectCitys.push(this.homeCity)
        }else{
          this.$message({
            message: '你已经添加了改城市',
            type: "error"
          });
        }
      }
      if(this.selectCitys.length == 0){
        this.citys = '全国'
      }else {
        this.citys = this.selectCitys.toString()
      }
    },

    delCity(index){
      this.selectCitys.splice(index,1);
      this.citys = this.selectCitys.toString();
      if(this.selectCitys.length == 0){
        this.citys = '全国'
      }
    },

    // 性别选择
    sexChange(){
      if(this.form.sex == -1){
        this.selectWoman = true;
        this.selectMan = true;
        this.form.womanAgeMin = -1;
        this.form.womanAgeMax = -1;
        this.form.womanHeightMin = -1;
        this.form.womanHeightMax = -1;
        this.form.manAgeMin = -1;
        this.form.manAgeMax = -1;
        this.form.manHeightMin = -1;
        this.form.manHeightMax = -1;
      }else if(this.form.sex == 1){
        this.selectWoman = false;
        this.selectMan = true;
        this.form.womanAgeMin = 0;
        this.form.womanAgeMax = 0;
        this.form.womanHeightMin = 0;
        this.form.womanHeightMax = 0;
        this.form.manAgeMin = -1;
        this.form.manAgeMax = -1;
        this.form.manHeightMin = -1;
        this.form.manHeightMax = -1;
      }else if(this.form.sex == 2){
        this.selectWoman = true;
        this.selectMan = false;
        this.form.manAgeMin = 0;
        this.form.manAgeMax = 0;
        this.form.manHeightMin = 0;
        this.form.manHeightMax = 0;
        this.form.womanAgeMin = -1;
        this.form.womanAgeMax = -1;
        this.form.womanHeightMin = -1;
        this.form.womanHeightMax = -1;
      }
    },



    // 获取上次状态
    getPage() {
      let _this = this;
      _this.dataLoading = true;
      getFormData(getThroughCodeLastRecord).then(function(data) {
        let {msg, code} = data;
        if(code == 200) {
          let datalist = data.data;
          // datalist = JSON.parse(JSON.stringify(list[0]));
          _this.form.lastSubTime = datalist['updateTime'];
          _this.form.totalPermissionState = datalist['totalPermissionState'];
          _this.form.sex = datalist['sex'];
          _this.form.manAgeMin = datalist['manAgeMin'];
          _this.form.manAgeMax = datalist['manAgeMax'];
          _this.form.manHeightMin = datalist['manHeightMin'];
          _this.form.manHeightMax = datalist['manHeightMax'];
          _this.form.womanAgeMin = datalist['womanAgeMin'];
          _this.form.womanAgeMax = datalist['womanAgeMax'];
          _this.form.womanHeightMin = datalist['womanHeightMin'];
          _this.form.womanHeightMax = datalist['womanHeightMax'];
          _this.form.startDate = datalist['startDate'] == null?'':datalist['startDate'] ;
          _this.form.endDate = datalist['endDate'] == null?'':datalist['endDate'];
          _this.form.startTime = datalist['startTime'];
          _this.form.endTime = datalist['endTime'];
          _this.citys = datalist['city']
          if(datalist['city'] == '全国'){
            _this.checkArea = true;
          }else {
            _this.selectCitys = datalist['city'].split(",");
          }
          if(_this.form.startDate == '' || _this.form.startDate == null ){
            _this.checkDate = true;
          }
          if(_this.form.startTime == -1 && _this.form.endTime == -1 ){
            _this.checkTime = true;
          }
          if(_this.form.manAgeMin == -1 && _this.form.manAgeMax == -1 ){
            _this.checkManAge = true;
          }
          if(_this.form.manHeightMin == -1 && _this.form.manHeightMax == -1 ){
            _this.checkManHeight = true;
          }
          if(_this.form.womanAgeMin == -1 && _this.form.womanAgeMax == -1 ){
            _this.checkWomAge = true;
          }
          if(_this.form.womanHeightMin == -1 && _this.form.womanHeightMax == -1 ){
            _this.checkWomHeight = true;
          }
          if(_this.form.manAgeMin == 0 && _this.form.manAgeMax == 0 && _this.form.manHeightMin == 0 && _this.form.manHeightMax == 0){
            _this.selectMan = false;
          }
          if(_this.form.womanAgeMin == 0 && _this.form.womanAgeMax == 0 && _this.form.womanHeightMin == 0 && _this.form.womanHeightMax == 0){
            _this.selectWoman = false;
          }
          // console.log(datalist);
        }else{
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        _this.dataLoading = false;
      })
    },


    //页面参数
    getPageParam() {
      let param = {};
      param['totalPermissionState'] = this.form.totalPermissionState;
      param['sex'] = this.form.sex;
      param['manAgeMin'] = this.form.manAgeMin;
      param['manAgeMax'] = this.form.manAgeMax;
      param['manHeightMin'] = this.form.manHeightMin;
      param['manHeightMax'] = this.form.manHeightMax;
      param['womanAgeMin'] = this.form.womanAgeMin;
      param['womanAgeMax'] = this.form.womanAgeMax;
      param['womanHeightMin'] = this.form.womanHeightMin;
      param['womanHeightMax'] = this.form.womanHeightMax;
      param['city'] = this.citys;
      param['startDate'] = this.form.startDate;
      param['endDate'] =this.form.endDate;
      param['startTime'] =this.form.startTime;
      param['endTime'] =this.form.endTime;
      this.pageParam = param;
      return param;
    },

    //提交页面
    submit(){
      this.dataLoading = true;
      this.sendPageReq(this.getPageParam());
    },

    // 发送页面列表请求
    sendPageReq(param) {
      let _this = this;
      postFormData(addThroughCodeData, param).then(function(data) {
        let {
          msg,
          code
        } = data;
        if(code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: '提交成功',
            type: 'success'
          });
        }else{
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        _this.dataLoading = false;
      })
          .catch(function(response) {
            _this.dataLoading = false;
          })
    },

  },
  mounted() {
    this.getHeight();
    this.getAge();
    this.getTimeArray();
    this.getPage();
  }
}
</script>

<style scoped>
.citys{
  float: left;
  height: 24px;
  background: #f6f6f6;
  border-radius: 4px;
  text-align: center;
  line-height: 24px;
  padding: 2px 8px;
  font-size: 14px;
  margin: 10px 10px 10px 0px;
}
.citys i{
  width:16px;
  height: 16px;
  cursor: pointer;
  padding-left: 8px;
}
.check{
  padding-left: 8px;
}
</style>
